import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { gridListStyles } from "../SharedComponent/styles/sharedStyles";

export const hubsStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...gridListStyles(theme)
    }),
);
